import axiosClient from "../axiosClient";

const route = "fabricColor";

export const updateRulers = async (rulerId, payload) => {
  const response = await axiosClient.put(
    `${route}/updateRuler/${rulerId}`,
    payload
  );
  return response;
};

export const updatePaperColor = async (id, data) => {
  try {
    const response = await axiosClient.put(`${route}/${id}`, data);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deletePaperColor = async (id) => {
  try {
    const response = await axiosClient.delete(`${route}/${id}`);
    return response;
  } catch (error) {
    console.error(error);
  }
};
